import { render } from "./SubscriberMailComponent.vue?vue&type=template&id=3b67eedf"
import script from "./SubscriberMailComponent.vue?vue&type=script&lang=js"
export * from "./SubscriberMailComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/subscribers/SubscriberMailComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b67eedf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b67eedf', __exports__)) {
    api.reload('3b67eedf', __exports__)
  }
  
  module.hot.accept("./SubscriberMailComponent.vue?vue&type=template&id=3b67eedf", () => {
    api.rerender('3b67eedf', render)
  })

}


export default __exports__